async function CalcEntryCFM(velocity, diameter) {
    //Referenced as "CFM"
    if (
        velocity.length > 0 &&
        diameter.length > 0
    ) {

        let response;

        response = await fetch("https://api.cssi.co/Calc/CalculateEntryCFM", {
            method: "POST",
            body: JSON.stringify(
                {
                    "velocity": velocity,
                    "diameter": diameter
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default CalcEntryCFM;